import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import {
  SearchAlert,
  UpsertSearchAlertParams,
} from 'ha/services/apiV2/types/SearchAlert';
import { APIV2_URL } from './constants';

export type UpsertSearchAlertCall = (
  params: UpsertSearchAlertParams,
) => Promise<{ data: SearchAlert }>;

export default (makeCall: MakeCall) => ({
  userId,
  city,
  country,
  startDate,
  endDate,
  kinds,
  minPrice,
  maxPrice,
  currency,
}: UpsertSearchAlertParams) =>
  makeCall<SearchAlert>('POST', `${APIV2_URL}/user/${userId}/search-alert`, {
    data: {
      city,
      country,
      startDate,
      endDate,
      kinds,
      minPrice,
      maxPrice,
      currency,
      smartMatch: true,
      alertType: 'daily',
    },
  });
